import annualData from '../api/annualData'
import { mergeUserContext } from '@/store/helpers'

const state = {
    annualDataMetadata: {},
    annualDataPersonRecords: [],
    retrieveAnnualDataError: false,
    confirmAnnualDataError: false,
    confirmAnnualDataSuccess: false,
    isAnnualDataConfirmed: false
}

const getters = {
    getAnnualDataMetadata: state => state.annualDataMetadata,
    getAnnualDataPersonRecords: state => state.annualDataPersonRecords,
    getConfirmAnnualDataError: state => state.confirmAnnualDataError,
    getConfirmAnnualDataSuccess: state => state.confirmAnnualDataSuccess,
    getRetrieveAnnualDataError: state => state.retrieveAnnualDataError,
    getIsAnnualDataConfirmed: state => state.isAnnualDataConfirmed
}

const actions = {
    async getAnnualDataPersonRecords ({ commit, rootState }, payload) {
        commit('SET_IS_ANNUAL_DATA_CONFIRMED', false)
        commit('SET_RETRIEVE_ANNUAL_DATA_ERROR', false)
        payload = mergeUserContext(payload, rootState)
        const response = await annualData.getAnnualDataPersonRecords(payload)

        if (!response.ok || !response.body) {
            commit('SET_RETRIEVE_ANNUAL_DATA_ERROR', response.status)
            return
        }

        if (response.body.metadata) {
            commit('SET_ANNUAL_DATA_METADATA', response.body.metadata)
        }

        commit('SET_IS_ANNUAL_DATA_CONFIRMED', response.body.isConfirmed)
        commit('SET_ANNUAL_DATA_PERSON_RECORDS', response.body.data || [])
    },

    async confirmAnnualData ({ commit, rootState }, payload) {
        payload = mergeUserContext(payload, rootState)
        const response = await annualData.confirmAnnualData(payload)

        if (!response.ok && !response.body.message.includes('email')) {
            commit('SET_CONFIRM_ANNUAL_DATA_ERROR', response.body.message || '')
            return
        }

        commit('SET_CONFIRM_ANNUAL_DATA_ERROR', response.body.message || '')
        commit('SET_ANNUAL_DATA_METADATA', response.body.metadata)
        commit('SET_IS_ANNUAL_DATA_CONFIRMED', response.body.isConfirmed)
        commit('SET_CONFIRM_ANNUAL_DATA_SUCCESS', response.ok)
    },

    async getIsAnnualDataConfirmed ({ commit, rootState }, payload = {}) {
        payload = mergeUserContext(payload, rootState)
        const response = await annualData.getIsAnnualDataConfirmed(payload)

        if (response.ok) {
            commit('SET_IS_ANNUAL_DATA_CONFIRMED', response.body.isConfirmed)
        }
    }
}

const mutations = {
    SET_RETRIEVE_ANNUAL_DATA_ERROR (state, payload) {
        state.retrieveAnnualDataError = payload
    },

    SET_ANNUAL_DATA_METADATA (state, payload) {
        state.annualDataMetadata = payload
    },

    SET_ANNUAL_DATA_PERSON_RECORDS (state, payload) {
        state.annualDataPersonRecords = payload
    },

    SET_CONFIRM_ANNUAL_DATA_ERROR (state, payload) {
        state.confirmAnnualDataError = payload
    },

    SET_CONFIRM_ANNUAL_DATA_SUCCESS (state, payload) {
        state.confirmAnnualDataSuccess = payload
    },

    SET_IS_ANNUAL_DATA_CONFIRMED (state, payload) {
        state.isAnnualDataConfirmed = payload
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/annualData.js